import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Badge,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { useNavigate } from 'react-router-dom';
import logo from '../../Assets/azul.png'; // Considerá usar un logo más futbolero si querés
import servicio1 from '../../services/servicio1';

// ...imports...

export default function Navbar() {
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorNotif, setAnchorNotif] = useState(null);
  const [notificaciones, setNotificaciones] = useState(0);
  const [listaNotificaciones, setListaNotificaciones] = useState([]);
  const [solicitudesDirectas, setSolicitudesDirectas] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loggedUserJSON = window.localStorage.getItem('loggedNoteAppUser');
    if (loggedUserJSON) {
      const user = JSON.parse(loggedUserJSON);
      setUser(user);

      const fetchNotificaciones = async () => {
        try {
          const cantidad = await servicio1.traernotificaciones(user.id);
          const notifs = cantidad[0] || [];
          const solicitudes = cantidad[1] || [];

          setListaNotificaciones(notifs);
          setSolicitudesDirectas(solicitudes);
          setNotificaciones(notifs.length + solicitudes.length);
        } catch (error) {
          console.error('Error al obtener notificaciones:', error);
        }
      };

      fetchNotificaciones();
      const interval = setInterval(fetchNotificaciones, 30000);
      return () => clearInterval(interval);
    }
  }, []);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleNotifClick = (event) => setAnchorNotif(event.currentTarget);
  const handleNotifClose = () => setAnchorNotif(null);

  const handleLogout = () => {
    window.localStorage.removeItem('loggedNoteAppUser');
    setUser(null);
    handleMenuClose();
    navigate('/falta1/login');
  };

  return (
    <AppBar
      position="static"
      sx={{
        background: 'linear-gradient(90deg, #1B5E20, #43A047)',
        boxShadow: 3,
        borderBottom: '3px solid #FFC107',
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <img src={logo} alt="Logo" width="45" height="45" />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              color: 'white',
              fontFamily: 'Roboto, sans-serif',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ⚽ Falta 1
          </Typography>
        </Box>

        <Box>
          <IconButton color="inherit" onClick={handleNotifClick}>
            <Badge
              badgeContent={notificaciones}
              color={notificaciones > 0 ? 'error' : 'default'}
              showZero
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>

          <Menu
            anchorEl={anchorNotif}
            open={Boolean(anchorNotif)}
            onClose={handleNotifClose}
          >
            {notificaciones === 0 ? (
              <MenuItem onClick={handleNotifClose}>
                No hay nuevas notificaciones
              </MenuItem>
            ) : (
              <>
                {solicitudesDirectas.length > 0 && (
                  <>
                    <MenuItem disabled>
                      <strong>Solicitudes directas</strong>
                    </MenuItem>
                    {solicitudesDirectas.map((item, index) => (
                      <MenuItem
                        key={`solicitud-${index}`}
                        onClick={() => {
                          handleNotifClose();
                          navigate('/falta1/solicitudes');
                        }}
                      >
                        ⚽ Tienes una solicitud de {item.nombre} ({item.apodo})
                      </MenuItem>
                    ))}
                  </>
                )}

                {listaNotificaciones.length > 0 && (
                  <>
                    <MenuItem disabled>
                      <strong>Otras notificaciones</strong>
                    </MenuItem>
                    {listaNotificaciones.map((item, index) => (
                      <MenuItem
                        key={`noti-${index}`}
                        onClick={() => {
                          handleNotifClose();
                          if (item.estado == 'solicitado') {
                            navigate('/solicitudes');
                          }
                        }}
                      >
                        {item.estado == 'solicitado'
                          ? '⚽ Solicitud para sumarse al partido'
                          : item.estado}
                      </MenuItem>
                    ))}
                  </>
                )}
              </>
            )}
          </Menu>

          <IconButton color="inherit" onClick={handleMenuOpen}>
            <AccountCircleIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            {user ? (
              <>
                <MenuItem onClick={() => { navigate('/falta1/principal'); handleMenuClose(); }}>
                  Inicio
                </MenuItem>
                <MenuItem onClick={() => { navigate('/falta1/perfil'); handleMenuClose(); }}>
                  Perfil
                </MenuItem>
                <MenuItem onClick={() => { navigate('/falta1/solicitudes'); handleMenuClose(); }}>
                  Solicitudes
                </MenuItem>
                <MenuItem onClick={() => { navigate('/falta1/jugadores'); handleMenuClose(); }}>
                  Jugadores
                </MenuItem>
                <MenuItem onClick={() => { navigate('/falta1/partidos'); handleMenuClose(); }}>
                  Partidos
                </MenuItem>
                <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
              </>
            ) : (
              <MenuItem onClick={() => { navigate('/falta1/login'); handleMenuClose(); }}>
                Iniciar sesión
              </MenuItem>
            )}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
